module.exports = __webpack_public_path__ + "static/pic03-0d9729ba8a47e673a4dff3754f8b5233.jpg";